export const GET_ACCOUNTS = "GET_ACCOUNTS";
export const GET_ACCOUNTS_SUCCESS = "GET_ACCOUNTS_SUCCESS";
export const UPDATE_ACCOUNTS = "UPDATE_ACCOUNTS_SUCCESS";
export const UPDATE_ACCOUNTS_FAILURE = "UPDATE_ACCOUNT_FAILURE";
export const UPDATE_ACCOUNTS_SUCCESS = "UPDATE_ACCOUNT_SUCCESS";
export const GET_PROVINCES_SUCCESS = "GET_PROVINCES_SUCCESS";
export const GET_PROVINCES = "GET_PROVINCES";
export const UPDATE_PROVINCES = "UPDATE_PROVINCES";
export const UPDATE_PROVINCES_FAILURE = "UPDATE_PROVINCES_FAILURE";
export const UPDATE_PROVINCES_SUCCESS = "UPDATE_PROVINCES_SUCCESS";
export const UPDATE_BUSINESS_ACCOUNTS = "UPDATE_BUSINESS_ACCOUNTS";
export const GET_BUSINESS_ACCOUNTS = "GET_BUSINESS_ACCOUNTS";
export const GET_BUSINESS_ACCOUNTS_SUCCESS = "GET_BUSINESS_ACCOUNTS_SUCCESS";
export const UPDATE_BUSINESS_ACCOUNTS_FAILURE =
  "UPDATE_BUSINESS_ACCOUNTS_FAILURE";
export const UPDATE_BUSINESS_ACCOUNTS_SUCCESS =
  "UPDATE_BUSINESS_ACCOUNTS_SUCCESS";



// WEBPACK FOOTER //
// ./src/components/dashboard/admin/accounts/accountsActionType.js